function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.414 12l7.293-7.293a1 1 0 00-1.414-1.414l-8 8a1 1 0 000 1.414l8 8a1 1 0 001.414-1.414L8.414 12z",
  fill: "#243143"
});

function SvgBackO24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNDE0MjEgMTJMMTUuNzA3MSA0LjcwNzExQzE2LjA5NzYgNC4zMTY1OCAxNi4wOTc2IDMuNjgzNDIgMTUuNzA3MSAzLjI5Mjg5QzE1LjMxNjYgMi45MDIzNyAxNC42ODM0IDIuOTAyMzcgMTQuMjkyOSAzLjI5Mjg5TDYuMjkyODkgMTEuMjkyOUM1LjkwMjM3IDExLjY4MzQgNS45MDIzNyAxMi4zMTY2IDYuMjkyODkgMTIuNzA3MUwxNC4yOTI5IDIwLjcwNzFDMTQuNjgzNCAyMS4wOTc2IDE1LjMxNjYgMjEuMDk3NiAxNS43MDcxIDIwLjcwNzFDMTYuMDk3NiAyMC4zMTY2IDE2LjA5NzYgMTkuNjgzNCAxNS43MDcxIDE5LjI5MjlMOC40MTQyMSAxMloiIGZpbGw9IiMyNDMxNDMiLz4KPC9zdmc+Cg==";
export { SvgBackO24 as ReactComponent };